import React, { FC, useEffect } from 'react';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { PropertyList } from 'components/property-settings/property-shared-styles';
import { ListItemButton, styled } from '@mui/material';
import { margin } from '@mui/system';

export type Design = {
    name: string;
    imageUrl: string;
};

type BtnListImgTypeSettingProps = {
    setting: Design[];
    propertyName: string;
    settingValue: string;
    handlePropertySelection: (propertyName: string, settingValue: string) => void;
};
const BtnListImgTypeSetting: FC<BtnListImgTypeSettingProps> = ({
    propertyName,
    settingValue,
    setting,
    handlePropertySelection,
}: BtnListImgTypeSettingProps) => {
    const { t: translate } = useTranslation(['construction-props']);
    const [selectedSetting, setSelectedSetting] = React.useState('');

    useEffect(() => {
        setSelectedSetting(settingValue || '');
    }, [settingValue]);

    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, settingValue: string) => {
        setSelectedSetting(settingValue);
        handlePropertySelection(propertyName, settingValue);
    };

    return (
        <PropertyList>
            {setting &&
                setting.map((elem, index) => {
                    const imgUrl =
                        elem.imageUrl && !elem.imageUrl.startsWith('/') ? `/${elem.imageUrl}` : elem.imageUrl;
                    return (
                        <CustomListItemButton
                            key={index}
                            sx={(theme) =>
                                selectedSetting === elem.name
                                    ? {
                                          background: `${theme.palette.primary.main} !important`,
                                          color: '#fff !important',
                                      }
                                    : {}
                            }
                            selected={selectedSetting === elem.name}
                            onClick={(event) => handleListItemClick(event, elem.name)}
                        >
                            {imgUrl ? <img src={imgUrl} /> : undefined}
                            <ListItemText
                                primary={translate(elem.name)}
                                primaryTypographyProps={{ fontSize: '13px' }}
                            />
                        </CustomListItemButton>
                    );
                })}
        </PropertyList>
    );
};

const CustomListItemButton = styled(ListItemButton)(({ theme }) => ({
    background: 'rgba(0, 0, 0, 0.08) !important',
    maxHeight: 30,
    flex: 'auto',
    width: 'auto',
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    '& img': {
        height: 20,
        marginRight: 5,
        background: '#fff',
        borderRadius: '50%',
        padding: 1,
    },
}));

export default BtnListImgTypeSetting;
